import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { CONTACT } from "@/data/content";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz" testId="datenschutz-page">
      <p className="text-zinc-500 text-sm">
        Datenschutzerklärung gemäß der Datenschutz-Grundverordnung (DSGVO).
      </p>

      <LegalSection heading="Verantwortlicher">
        <p>
          inn&apos;spective — {CONTACT.founder}
          <br />
          {CONTACT.address}, Österreich
          <br />
          E-Mail:{" "}
          <a href={`mailto:${CONTACT.email}`} className="brand-text font-medium">
            {CONTACT.email}
          </a>
        </p>
      </LegalSection>

      <LegalSection heading="Allgemeines">
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist mir ein wichtiges
          Anliegen. Ich verarbeite Ihre Daten ausschließlich auf Grundlage der
          gesetzlichen Bestimmungen (DSGVO, TKG 2021). In dieser
          Datenschutzerklärung informiere ich Sie über die wichtigsten Aspekte
          der Datenverarbeitung im Rahmen dieser Website.
        </p>
      </LegalSection>

      <LegalSection heading="Kontaktformular">
        <p>
          Wenn Sie mir über das Kontaktformular Anfragen zukommen lassen, werden
          Ihre Angaben (Name, E-Mail-Adresse, optional Telefonnummer und Ihre
          Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von
          Anschlussfragen bei mir gespeichert und per E-Mail an mich übermittelt.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Die Verarbeitung erfolgt auf Basis
          Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie zur Durchführung
          vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO).
        </p>
        <p>
          <strong>Speicherdauer:</strong> Diese Daten gebe ich nicht ohne Ihre
          Einwilligung weiter und lösche sie, sobald sie für den Zweck der
          Verarbeitung nicht mehr erforderlich sind bzw. ich schränke die
          Verarbeitung ein, sofern gesetzliche Aufbewahrungspflichten bestehen.
        </p>
      </LegalSection>

      <LegalSection heading="Server-Logfiles & Hosting">
        <p>
          Beim Besuch dieser Website können technisch notwendige Daten (z. B.
          IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten,
          Browsertyp) automatisch durch den Hosting-Provider verarbeitet werden.
          Dies dient der Gewährleistung eines sicheren und stabilen Betriebs
          (Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse).
        </p>
      </LegalSection>

      <LegalSection heading="Auftragsverarbeiter (E-Mail-Versand)">
        <p>
          Zur Zustellung der über das Kontaktformular gesendeten Nachrichten
          setze ich einen E-Mail-Versanddienstleister ein. Mit diesem besteht
          eine entsprechende Vereinbarung zur Auftragsverarbeitung gemäß Art. 28
          DSGVO.
        </p>
      </LegalSection>

      <LegalSection heading="Ihre Rechte">
        <p>
          Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung,
          Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch zu. Wenn
          Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
          Datenschutzrecht verstößt, können Sie sich bei mir oder bei der
          Datenschutzbehörde{" "}
          <a
            href="https://www.dsb.gv.at"
            target="_blank"
            rel="noopener noreferrer"
            className="brand-text font-medium"
          >
            (dsb.gv.at)
          </a>{" "}
          beschweren.
        </p>
      </LegalSection>

      <LegalSection heading="Kontakt zum Datenschutz">
        <p>
          Bei Fragen zum Datenschutz erreichen Sie mich unter{" "}
          <a href={`mailto:${CONTACT.email}`} className="brand-text font-medium">
            {CONTACT.email}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}

